import React from 'react';
import STRINGS from 'constants/strings';
import InfoIcon from '@tradera/tradera-ui/icons/info.svg?jsx';

const ToBuyLink = ({ isLoggedIn }) => {
    return (
        <a
            href="/info/how-to-buy"
            aria-label={STRINGS.TO_BUY}
            className="slim-header__menu-link px-3 pr-md-4 d-flex align-items-center"
            data-ga-category="Header"
            data-ga-action="Navigation"
            data-ga-label={STRINGS.TO_BUY}
            data-nav-how-to-buy>
            <InfoIcon className="icon icon-dark d-none d-md-block" />
            <InfoIcon className="icon icon-dark icon-md d-md-none d-block" />

            <span
                className={`slim-header__link-text d-none ${
                    isLoggedIn ? 'd-lg-inline' : 'd-xl-inline'
                } bold`}>
                {STRINGS.TO_BUY}
            </span>
        </a>
    );
};

export default ToBuyLink;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/site-header/to-buy-link.jsx